import { Hero } from '@/components/organisms/Admin/Credits/Hero'
import { Historic } from '@/components/organisms/Admin/Credits/Historic'

export function CreditsPage() {
	return (
		<>
			<Hero />
			<Historic />
		</>
	)
}
